import React, { useState, useEffect } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';

const MainLayout = ({ children }) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    useEffect(() => {
        document.documentElement.style.setProperty('--sidebar-width', isSidebarCollapsed ? '80px' : '280px');

        // Em vez de apenas no final, forçamos o FullCalendar a re-calcular seu tamanho a cada frame 
        // durante a animação de 0.3s (300ms) para grudar o calendário perfeitamente sem "borda vazia".
        let startTime = Date.now();
        const duration = 320;
        let animationFrameId;

        const animateResize = () => {
            window.dispatchEvent(new Event('resize'));
            if (Date.now() - startTime < duration) {
                animationFrameId = requestAnimationFrame(animateResize);
            } else {
                // garante um último evento no final
                window.dispatchEvent(new Event('resize'));
            }
        };

        animationFrameId = requestAnimationFrame(animateResize);

        return () => cancelAnimationFrame(animationFrameId);
    }, [isSidebarCollapsed]);

    const toggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    return (
        <Flex h="100vh" bg="background" overflow="hidden">
            <Sidebar
                isCollapsed={isSidebarCollapsed}
                onToggle={toggleSidebar}
            />
            <Flex
                direction="column"
                flex="1"
                minW={0}
                w="full"
                h="100vh"
            >
                <Header />
                <Box flex="1" overflow="auto" p={8}>
                    {children}
                </Box>
                <Footer />
            </Flex>
        </Flex>
    );
};

export default MainLayout;